<template>
    <!-- Desktop -->
    <div
        v-if="!isMobile"
        class="sticky bottom-[10vh] left-0 hidden h-[160px] w-fit -translate-y-[287px] flex-col items-center gap-4 font-en font-bold text-base-black lg:flex lg:pl-[var(--padding-lg)]"
    >
        <AtomsBody1 style="writing-mode: vertical-rl">SHARE</AtomsBody1>
        <ul class="flex flex-col items-center gap-2">
            <li v-for="s in shareButtons" :key="s.name">
                <button
                    class="slt-flex-center h-12 w-12 rounded-full bg-base-black text-white transition-transform duration-200 ease-in-out hover:scale-[105%] active:scale-[95%]"
                    :class="s.name === 'LINE' ? 'slt-share-line' : ''"
                    v-html="s.icon"
                    @click="share(s.name)"
                    v-sendGAsignal="{
                        event_category: route.path,
                        event_label: s.label,
                    }"
                />
            </li>
        </ul>
    </div>
    <!-- Mobile/Tablet -->
    <ul v-if="isMobile" class="flex items-center gap-2 self-start lg:hidden">
        <li v-for="s in shareButtons" :key="s.name">
            <button
                class="slt-flex-center h-10 w-10 rounded-full bg-base-black text-white transition-transform duration-200 ease-in-out hover:scale-[105%] active:scale-[95%]"
                :class="s.name === 'LINE' ? 'slt-share-line' : ''"
                v-html="s.icon"
                @click="share(s.name)"
                v-sendGAsignal="{
                    event_category: route.path,
                    event_label: s.label,
                }"
            />
        </li>
    </ul>
</template>

<script setup>
defineProps({
    isMobile: {
        type: Boolean,
        default: false,
    },
});
const { $toast } = useNuxtApp();
const { t } = useI18n();
const route = useRoute();
const shareButtons = [
    {
        name: "LINE",
        icon: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="#F7F8F8" d="M22.5 10.52C22.5 5.82 17.8 2 12.02 2c-5.78 0-10.5 3.82-10.5 8.52 0 4.2 3.74 7.73 8.78 8.4.35.07.81.22.93.52.1.26.07.68.03.95l-.15.9c-.04.26-.2 1.03.91.56 1.12-.47 6.05-3.56 8.25-6.1 1.52-1.66 2.25-3.35 2.25-5.23Z"/><path fill="#000" d="M19.02 13.23a.2.2 0 0 0 .2-.2v-.75a.2.2 0 0 0-.2-.2h-2v-.77h2a.2.2 0 0 0 .2-.2v-.75a.2.2 0 0 0-.2-.2h-2V9.4h2a.2.2 0 0 0 .2-.2v-.74a.2.2 0 0 0-.2-.2h-2.95a.2.2 0 0 0-.2.2v4.57c0 .12.09.2.2.2h2.95ZM8.1 13.23a.2.2 0 0 0 .21-.2v-.75a.2.2 0 0 0-.2-.2h-2V8.45a.2.2 0 0 0-.2-.2h-.75a.2.2 0 0 0-.2.2v4.57c0 .12.09.2.2.2h2.95ZM9.89 8.25h-.75a.2.2 0 0 0-.2.2v4.58c0 .1.1.2.2.2h.75a.2.2 0 0 0 .2-.2V8.45a.2.2 0 0 0-.2-.2ZM14.95 8.25h-.75a.2.2 0 0 0-.2.2v2.72l-2.1-2.83v-.02l-.02-.02h-.02v-.01h-.01v-.01h-.02v-.01h-.02l-.01-.01h-.03l-.01-.01H11a.2.2 0 0 0-.2.2v4.58c0 .11.09.2.2.2h.74a.2.2 0 0 0 .2-.2v-2.72l2.1 2.84a.2.2 0 0 0 .06.05h.02v.01h.02l.01.01.06.01h.74a.2.2 0 0 0 .2-.2V8.45a.2.2 0 0 0-.2-.2Z"/></svg>`,
        label: "分享至 line",
    },
    {
        name: "FACEBOOK",
        icon: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="#F7F8F8" fill-rule="evenodd" d="M9.27 12.98v8.86h4.13V13.1h2.8l.72-3.7H13.4v-2.7c0-.37.12-.86.73-.86h1.94V2.16h-3.76c-1.22 0-3.04 1.6-3.04 3.45v3.8H7.08v3.7l2.19-.13Z" clip-rule="evenodd"/></svg>`,
        label: "分享至 facebook",
    },
    {
        name: "X",
        icon: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="#F7F8F8" d="M10.49 14.65 15.25 21h7l-7.86-10.48L20.93 3h-2.65l-5.12 5.89L8.75 3h-7l7.51 10.02L2.32 21h2.65l5.52-6.35ZM16.25 19 5.75 5h2l10.5 14h-2Z"/></svg>`,
        label: "分享至 twitter",
    },
    {
        name: "LINK",
        icon: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="#F7F8F8" d="M3.56 20.84a5.06 5.06 0 0 0 4.08 1.67c1.47-.13 2.93-.9 4.37-2.3l2.05-1.97c1.46-1.44 2.24-2.91 2.34-4.42a5.01 5.01 0 0 0-1.74-4.07 6.06 6.06 0 0 0-1.61-1.26 5.84 5.84 0 0 0-1.63 2.08 6.45 6.45 0 0 1 1.48.95c.67.68.96 1.46.84 2.32a4.71 4.71 0 0 1-1.53 2.65l-1.88 1.87c-.91.89-1.8 1.4-2.65 1.52a2.61 2.61 0 0 1-2.3-.84 2.64 2.64 0 0 1-.87-2.31c.1-.87.61-1.75 1.52-2.63l1.03-1a3.02 3.02 0 0 1-.3-.91 6.55 6.55 0 0 1 .03-2.42l-2.62 2.6c-1.42 1.43-2.19 2.89-2.3 4.38a5.1 5.1 0 0 0 1.69 4.09Z"/><path fill="#F7F8F8" d="M20.55 3.69a5.03 5.03 0 0 0-4.07-1.67c-1.47.12-2.93.88-4.37 2.3l-2.06 1.96C8.59 7.72 7.8 9.19 7.7 10.7a5.01 5.01 0 0 0 1.74 4.08 6.95 6.95 0 0 0 1.61 1.26c.34-.26.67-.6 1-1.01.33-.41.54-.77.65-1.06a4.66 4.66 0 0 1-1.48-.96 2.66 2.66 0 0 1-.85-2.33c.11-.86.62-1.74 1.54-2.65l1.86-1.86c.92-.9 1.81-1.4 2.67-1.52.86-.12 1.63.16 2.3.83.69.67.97 1.45.86 2.32a4.6 4.6 0 0 1-1.52 2.63l-1.03 1.02c.13.2.23.5.3.9.07.4.1.8.1 1.24 0 .44-.04.83-.14 1.19l2.62-2.62c1.43-1.43 2.2-2.9 2.3-4.38a5.11 5.11 0 0 0-1.69-4.1Z"/></svg>`,
        label: "複製網址",
    },
];

function share(platform) {
    let postUrl = window.location.href;
    let shareUrl = "";

    switch (platform) {
        case "LINE":
            postUrl = encodeURIComponent(postUrl);
            shareUrl = `https://social-plugins.line.me/lineit/share?url=${postUrl}`;
            window.open(shareUrl, "_blank", "noopener,noreferrer");
            break;
        case "FACEBOOK":
            postUrl = encodeURIComponent(postUrl);
            shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${postUrl}`;
            window.open(shareUrl, "_blank", "noopener,noreferrer");
            break;
        case "X":
            postUrl = encodeURIComponent(postUrl);
            shareUrl = `https://twitter.com/intent/tweet?url=${postUrl}`;
            window.open(shareUrl, "_blank", "noopener,noreferrer");
            break;
        case "LINK":
            if (
                navigator.clipboard &&
                typeof navigator.clipboard.writeText === "function"
            ) {
                navigator.clipboard
                    .writeText(postUrl)
                    .then(() => {
                        $toast.success(t("notification.linkCopied"));
                    })
                    .catch((err) => {
                        // console.error("Failed to copy link: ", err);
                        $toast.error(t("notification.linkCopyFailed"));
                    });
            } else {
                // console.error("Clipboard API not supported.");
                $toast.error(t("notification.linkCopyFailed"));
            }
            break;
    }
}
</script>

<style scoped>
:deep(svg) {
    @apply h-6 w-6;
}
</style>
